import { IpaRow } from "./Ipa";
import { IpaChartProps } from "./IpaChart";

interface ClickChartProps extends IpaChartProps {
  readonly includeAspirated?: boolean;
}

/** show IPA clicks chart */
export function ClickChart(props: ClickChartProps) {
  const clicks = [['ʘ', ''], ['ǀ', ''], ['ǃ', ''], ['‼', ''], ['ǂ', ''], ['ǁ', '']];
  const basics = [['k͡ʘ', 'ɡ͡ʘ'], ['k͡ǀ', 'ɡ͡ǀ'], ['k͡ǃ', 'ɡ͡ǃ'], ['k͡‼', 'ɡ͡‼'], ['k͡ǂ', 'ɡ͡ǂ'], ['k͡ǁ', 'ɡ͡ǁ']];
  const basicAsp = [['k͡ʘʰ', 'ɡ͡ʘʰ'], ['k͡ǀʰ', 'ɡ͡ǀʰ'], ['k͡ǃʰ', 'ɡ͡ǃʰ'], ['k͡‼ʰ', 'ɡ͡‼ʰ'], ['k͡ǂʰ', 'ɡ͡ǂʰ'], ['k͡ǁʰ', 'ɡ͡ǁʰ']];
  const nasals = [['', 'ŋ͡ʘ'], ['', 'ŋ͡ǀ'], ['', 'ŋ͡ǃ'], ['', 'ŋ͡‼'], ['', 'ŋ͡ǂ'], ['', 'ŋ͡ǁ']];
  const nasalAsp = [['', 'ŋ͡ʘʰ'], ['', 'ŋ͡ǀʰ'], ['', 'ŋ͡ǃʰ'], ['', 'ŋ͡‼ʰ'], ['', 'ŋ͡ǂʰ'], ['', 'ŋ͡ǁʰ']];
  return (
    <table>
      <thead>
        <tr>
          <td></td>
          <th>Bilabial</th>
          <th>Dental</th>
          <th>Alveolar</th>
          <th>Retroflex</th>
          <th>Palatal</th>
          <th>Lateral</th>
        </tr>
      </thead>
      <tbody>
        <IpaRow title='Clicks' symbols={clicks} chartProps={props} />
        <IpaRow title='Basics' symbols={basics} chartProps={props} />
        {props.includeAspirated ? <IpaRow title='Aspirated' symbols={basicAsp} chartProps={props} /> : undefined}
        <IpaRow title='Nasal' symbols={nasals} chartProps={props} />
        {props.includeAspirated ? <IpaRow title='Aspirated nasals' symbols={nasalAsp} chartProps={props} /> : undefined}
      </tbody>
    </table>
  );
}
